import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const onlineUsersApi = {
  // GET
  get: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/online-users`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default onlineUsersApi;
